import React from 'react';
import PropTypes from 'prop-types';

import { IconGift } from '@src/components/Icon';

import useStyles from 'isomorphic-style-loader/useStyles';
import css from './style.module.sass';

const GiftLine = (props) => {
	useStyles(css);
	const { description, onClickMore, Icon } = props;

	const handleClickMore = React.useCallback(
		(e) => {
			e.preventDefault();
			if (onClickMore) onClickMore();
		},
		[onClickMore],
	);

	return (
		<div
			className={css.wrap}
			role="button"
			tabIndex={0}
			onClick={handleClickMore}
		>
			{Icon && (
				<div className={css.iconGift}>
					<Icon />
				</div>
			)}

			{description && (
				<span
					className={css.label}
					// eslint-disable-next-line react/no-danger
					dangerouslySetInnerHTML={{ __html: description }}
				/>
			)}

			{onClickMore && <div className={css.link}>{t('Подробнее')}</div>}
		</div>
	);
};

GiftLine.propTypes = {
	/**
	 * Описание.
	 */
	description: PropTypes.string,
	/**
	 * Обработчик клика по компоненту.
	 */
	onClickMore: PropTypes.func,
	/**
	 *
	 */
	Icon: PropTypes.elementType,
};

GiftLine.defaultProps = {
	description: undefined,
	onClickMore: undefined,
	Icon: (props) => <IconGift {...props} />,
};

export default GiftLine;
